const createTypeOfResource = (resource) => {
  switch (resource) {
    case 'KeyUpdates':
    case 'Consultations':
    case 'Events':
    case 'PolicyAsks':
    case 'CommitteePublications':
      return resource.substring(0, resource.length - 1);
    case 'Tweets':
      return 'tweet';
    case 'Stakeholders':
      return 'stakeholder';
    case 'UpcomingEvents':
      return 'Event';
    case 'SocialMedia':
      return 'tweet';
    case 'LibraryMaterial':
    case 'CommonsLibraryArticles':
      return 'CommonsLibraryArticle';
    case 'Influence':
      return 'UserContent';
    case 'ParliamentLive':
      return 'RealtimeUtterance';
    case 'Regulations':
      return 'CommitteePublication';
    default:
      return resource;
  }
};

const changeTypeOfResource = (section) => {
  switch (section) {
    case 'PolicyAsks':
    case 'BriefingMaterial':
    case 'LobbyingMaterial':
    case 'Campaigns':
      return 'UserContent';
    case 'LibraryMaterial':
      return 'CommonsLibraryArticle';
    case 'ElectionKeyUpdates':
      return 'KeyUpdate';
    case 'ParliamentLive':
      return 'RealtimeUtterance';
    default:
      return createTypeOfResource(section);
  }
};

export { changeTypeOfResource };
export default createTypeOfResource;
